import React, {Component} from "react";

const Banner = ()=>{
    return (
        <div></div>
    //    <div className="row">
    //    <div className='col' style={{
    //        padding: 10,
    //        backgroundColor: "rgb(0, 88, 161)",
    //        color: "white",
    //        marginLeft: 15,
    //        marginBottom: 1
    //    }}>
    //        <p><b>Important Notice: Scheduled Upgrade and Maintenance</b></p>
    //        <p>Dear KLUWER LAW ONLINE Users! we're dedicated to enhancing your experience on our platform. To achieve this, we've planned a major upgrade and maintenance during <b>November 1-30, 2023</b>. You may experience brief service interruptions. We'll work to minimize any disruptions or downtime.
    //        </p>
    //    </div>
    //</div>
    )
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.jsx